import TagManager from "react-gtm-module";

export function addToDataLayerGTM(dataLayer) {
  const tagManagerArgs = {
    dataLayer,
    dataLayerName: "dataLayer",
  };

  TagManager.dataLayer(tagManagerArgs);
}



// WEBPACK FOOTER //
// ./src/utils/addToDataLayerGTM.js